import { useEffect, useRef, useState } from 'react'
import type { UnitType } from '@/types/search'

export const useDebouncing = (
  sectionModulus: string,
  sectionModulusUnit: UnitType,
  bendingMoment: string,
) => {
  const [debouncedSectionModulus, setDebouncedSectionModulus] = useState('')
  const [debouncedBendingMoment, setDebouncedBendingMoment] = useState('')
  const sectionModulusTimerRef = useRef<NodeJS.Timeout | null>(null)
  const bendingMomentTimerRef = useRef<NodeJS.Timeout | null>(null)

  // Debounce for section modulus (1 second for imperial)
  useEffect(() => {
    if (sectionModulusTimerRef.current) {
      clearTimeout(sectionModulusTimerRef.current)
    }

    const debounceDelay = sectionModulusUnit === 'imperial' ? 1000 : 0 // 1 second for imperial, no delay for metric

    sectionModulusTimerRef.current = setTimeout(() => {
      setDebouncedSectionModulus(sectionModulus)
    }, debounceDelay)

    return () => {
      if (sectionModulusTimerRef.current) {
        clearTimeout(sectionModulusTimerRef.current)
      }
    }
  }, [sectionModulus, sectionModulusUnit])

  // Debounce for bending moment (1 second for all)
  useEffect(() => {
    if (bendingMomentTimerRef.current) {
      clearTimeout(bendingMomentTimerRef.current)
    }

    bendingMomentTimerRef.current = setTimeout(() => {
      setDebouncedBendingMoment(bendingMoment)
    }, 1000) // 1 second debounce for all units

    return () => {
      if (bendingMomentTimerRef.current) {
        clearTimeout(bendingMomentTimerRef.current)
      }
    }
  }, [bendingMoment])

  return {
    debouncedSectionModulus,
    debouncedBendingMoment,
  }
}
